// extracted by mini-css-extract-plugin
module.exports = {"section":"_3jXoX","ctaText":"_3pPgz"};